import type { Timezone } from 'next-intl';

type DrawingDateParts = {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
};

/**
 * Extracts calendar/time parts from a drawing date in the given timezone.
 */
function getDrawingDateParts(drawingDate: string | Date, timeZone: Timezone | undefined): DrawingDateParts {
  const date = drawingDate instanceof Date ? drawingDate : new Date(drawingDate);
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hourCycle: 'h23',
  }).formatToParts(date);

  const read = (type: Intl.DateTimeFormatPartTypes): number => Number(parts.find(part => part.type === type)?.value ?? 0);

  return {
    year: read('year'),
    month: read('month'),
    day: read('day'),
    hour: read('hour'),
    minute: read('minute'),
  };
}

export { getDrawingDateParts };
export type { DrawingDateParts };
